import dayjs from 'dayjs';

const toDayjs = (value) => {
    if (!value) return null;
    const d = dayjs.isDayjs(value) ? value : dayjs(value);
    return d.isValid() ? d : null;
};

/** 日期選擇器：開始時間預設 00:00:00（回傳 dayjs） */
export const applyStartOfDay = (value) => {
    const d = toDayjs(value);
    return d ? d.hour(0).minute(0).second(0) : null;
};

/** 日期選擇器：結束時間預設 23:59:59（回傳 dayjs） */
export const applyEndOfDay = (value) => {
    const d = toDayjs(value);
    return d ? d.hour(23).minute(59).second(59) : null;
};

/** 日期選擇器：開始時間預設 00:00:00（回傳字串） */
export const applyStartOfDayString = (value) => {
    const d = applyStartOfDay(value);
    return d ? d.format('YYYY-MM-DD HH:mm:ss') : null;
};

/** 日期選擇器：結束時間預設 23:59:59（回傳字串） */
export const applyEndOfDayString = (value) => {
    const d = applyEndOfDay(value);
    return d ? d.format('YYYY-MM-DD HH:mm:ss') : null;
};

/** 區間選擇器：起訖分別套用 00:00:00 / 23:59:59（回傳 dayjs 陣列） */
export const applyRangeBoundaries = (dates) => {
    if (!dates || dates.length !== 2) return dates ?? null;
    return [applyStartOfDay(dates[0]), applyEndOfDay(dates[1])];
};

/** 區間選擇器：起訖分別套用 00:00:00 / 23:59:59（回傳字串陣列） */
export const applyRangeBoundaryStrings = (dates) => {
    if (!dates || dates.length !== 2) return dates ?? null;
    return [applyStartOfDayString(dates[0]), applyEndOfDayString(dates[1])];
};
